// extracted by mini-css-extract-plugin
export default {"embedInputWrapper":"Liw4mD9ZZn","embedInputWarningButton":"k0fk2ut_m3"};